"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFeatureTooling = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var react_1 = __importStar(require("react"));
var analytics_1 = require("../analytics");
var FEATURE_CONTEXT_ERROR = "useFeatureContext couldn't access the FeatureContext object.\n\nThis might be due to\n- useFeatureContext was used outside a parent FeatureContext\n- there are multiple versions of ui-tools installed and FeatureContext was imported from a different one\n";
function createFeatureTooling(defaults, renderEvent) {
    var FeatureContext = (0, react_1.createContext)(null);
    function useFeatureContext() {
        var featureCtx = (0, react_1.useContext)(FeatureContext);
        if (featureCtx === null) {
            throw new Error(FEATURE_CONTEXT_ERROR);
        }
        return featureCtx;
    }
    function FeatureProvider(_a) {
        var children = _a.children, features = _a.features, timeout = _a.timeout;
        var defaultValue = timeout
            ? null
            : __assign(__assign({}, defaults), features);
        var _b = (0, react_1.useState)(defaultValue), featureState = _b[0], setFeatures = _b[1];
        var setPartialFeatures = function (features) {
            setFeatures(function (previousState) {
                return previousState
                    ? __assign(__assign({}, previousState), features) : __assign(__assign({}, defaults), features);
            });
        };
        var contextValue = {
            features: featureState,
            setFeatures: setPartialFeatures,
        };
        (0, react_1.useEffect)(function () {
            if (timeout) {
                var timer_1 = setTimeout(function () {
                    if (!featureState) {
                        setPartialFeatures(features || {});
                    }
                }, timeout);
                return function () {
                    clearTimeout(timer_1);
                };
            }
        });
        return (react_1.default.createElement(FeatureContext.Provider, { value: contextValue }, children));
    }
    function Feature(_a) {
        var children = _a.children, feature = _a.feature, shouldLogEvent = _a.shouldLogEvent, _b = _a.Loading, Loading = _b === void 0 ? function () { return null; } : _b;
        var features = useFeatureContext().features;
        var dispatch = (0, analytics_1.useAnalytics)().dispatch;
        if (features) {
            shouldLogEvent &&
                renderEvent &&
                dispatch((0, deepmerge_1.default)(renderEvent, {
                    properties: {
                        featureName: feature,
                        featureValue: features[feature],
                    },
                }));
            return children(features[feature]);
        }
        else {
            return react_1.default.createElement(Loading, null);
        }
    }
    return { FeatureContext: FeatureContext, FeatureProvider: FeatureProvider, useFeatureContext: useFeatureContext, Feature: Feature };
}
exports.createFeatureTooling = createFeatureTooling;
